// extracted by mini-css-extract-plugin
module.exports = {"copy":"EditorialCopy_copy__W_6Z8"};